export default "__VITE_ASSET__DNQfOBNI__"